<template>
   <div>
      <TopoComponent></TopoComponent>
      
      <div class="container chamada" v-if="!temSolicitacao && !temChamadaAtiva">
        <h3 class="text-center">No momento não existe nenhum atendimento solicitado e disponível para iniciar. </h3>
        <h4 class="text-center mt-2">Você pode continuar aguardando ou fechar essa tela.</h4>
      </div>  
      
      <!-- container chamada -->
      <div class="container chamada" v-if="temSolicitacao || temChamadaAtiva">
        <h2 v-if="!chamadaIniciada">{{nomeUsuario}}, seu atendimento iniciará em breve...</h2>
        <h2 v-if="chamadaIniciada">{{nomeUsuario}}, você está conectado com o(a) {{chamada.nomeProfissional}}...</h2>
        <div class="row mt-3">
          <!-- aguardando profissional -->
          <div class="col-lg-12 aguardando">
            <div class="box">
              <div class="row bg-white">
                <div class="col-12" v-if="medicoDisponivel && !chamadaIniciada">
                  <img :src="chamada.urlFoto" class="photo">
                  <h2>{{chamada.nomeProfissional}} está lhe aguardando <img src="@/assets/img/loading.gif" width="50px" height="50px"></h2>
                  <button type ="button" class="bt-primary mt-2 btn-danger" @click="abrirAtendimento">Acesse agora o atendimento, clique aqui!</button>
                </div>
                <div class="col-12" v-if="!medicoDisponivel && !chamadaIniciada">
                  <img src="@/assets/img/medico.svg" alt="" class="photo mb-2">
                  <br>
                  <h4>Estamos selecionando um {{solicitacao.tipoProfissional}} para atendê-lo <img src="@/assets/img/loading.gif" width="50px" height="50px"></h4>
                  <h3>Previsão de atendimento: {{solicitacao.horaPrevistaAtendimento}}</h3>
                </div>
                <div class="col-12" v-if="chamadaIniciada">
                    <iframe allow="camera; microphone" :src="urlvideo" name="zoomConference" id="zoomConference" allowfullscreen="true" style="min-height: 430px; width: 100%; border: 0px;"></iframe>
                </div>  
              </div>
              <div class="row bg-gray">
                <div class="col-6">
                  <span class="ico-wifi"></span>
                  <p>Procure sempre consultar-se<br>utilizando o Wi-Fi.</p>
                </div>
                <div class="col-6">
                  <span class="ico-lamp"></span>
                  <p>Deixe o ambiente bem iluminado.<br>Assim todos podem se ver.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <!-- fim container chamada -->
  
  </div>   
</template>

<script>
import TopoComponent from '@/components/TopoComponent'

export default {
  components: { TopoComponent },
  name: 'sala-espera',
  created(){
     this.poolingImediatoAtivo()
     this.poolingChamadaAtiva()
     
     //poolings
    setInterval(()=>{ 
       this.poolingImediatoAtivo()
    }, 5000)
    setInterval(()=>{ 
       this.poolingChamadaAtiva()
    }, 8000)
  },
  data() {
    return {
        isMobile: (/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())),
        urlvideo: null,
        temSolicitacao: false,
        temChamadaAtiva: false,
        chamadaIniciada: false,
        solicitacao: {
          idProtocolo: null,
          horaPrevistaAtendimento: null,
          tipoProfissional: null
        },
        chamada:{
           nomeProfissional: null,
           urlFoto: null,
           zoomMeetingUrl: null,
           tokenChamada: null
        },
        medicoDisponivel: false,
        nomeUsuario: sessionStorage.getItem("usuario-nome")
    }
  },
  methods : {
    abrirAtendimento(){
       if(this.isMobile){
           if(this.chamada.zoomMeetingId != null){
               this.abrirAplicativoViaLinkMagico()
           }else{
                 //jtsi
                this.$notify({
                    duration: 4000,
                    group: 'mensagens',
                    type: 'error', 
                    title: 'Mensagem',
                    text: 'A tecnologia habilita para a clinica, não suporta mobile.'
                })
           }
       }else{
          if(this.chamada.zoomMeetingId != null){
              //zoom
              this.urlvideo = this.chamada.zoomMeetingUrl
              this.chamadaIniciada = true
          }else{
              //jitsi
              this.urlvideo = 'https://meeting.conexasaude.com.br/'+this.chamada.tokenChamada
              this.chamadaIniciada = true
          }
       }
    },
    poolingImediatoAtivo(){
        this.$conexaApi.get('/integration/app-paciente/atendimento/imediato/ativo')
        .then((response) => {
            if(response.data.object != null){
               this.temSolicitacao = true
               this.solicitacao = response.data.object
            }else{
              this.temSolicitacao = false
            }
        }) .catch((error) => {
           console.log(error.response.data.msg)
        }).finally(() => {
           NProgress.done()
        })   
     },
     poolingChamadaAtiva(){
        this.$conexaApi.get('/integration/app-paciente/atendimento/chamada/ativa')
        .then((response) => {
           if(response.data.object != null){
               this.temChamadaAtiva = true
               this.medicoDisponivel = true
               this.chamada = response.data.object
               //this.abrirAtendimento()
            }else{
              this.temChamadaAtiva = false
              this.medicoDisponivel = false
            }
        }) .catch((error) => {
            this.$notify({
                duration: 4000,
                group: 'mensagens',
                type: 'error', 
                title: 'Mensagem',
                text: error.response.data.msg
            })
        }).finally(() => {
           NProgress.done()
        })   
     },
     abrirAplicativoViaLinkMagico(){
      this.$conexaApi.get('/integration/app-paciente/usuario/gerar-link-magico-app-conexa')
        .then((response) => {
            location.href = response.data.object
        }) .catch((error) => {
            this.$notify({
                duration: 4000,
                group: 'mensagens',
                type: 'error', 
                title: 'Mensagem',
                text: error.response.data.msg
            })
        }).finally(() => {
           NProgress.done()
        })   
     }
  }
}
</script>
